<div class="flex justify-center items-center w-full h-full">
  <ib-spinner *ngIf="loading"></ib-spinner>

  <div *ngIf="error && !loading">
    <div class="flex justify-center">
      <i class="material-icons text-30px text-error!">warning_amber</i>
    </div>
    <div class="text-error text-center p-5 max-w-450px text-22px">
      {{ 'page.check-regist-email-link.err-msg' | transloco }}
    </div>

    <div class="text-center p-5 max-w-450px">{{ error }}</div>
    <div class="flex flex-col justify-center items-center">
      <ng-container *ngIf="isLoggedIn">
        <button
          mat-button
          type="button"
          (click)="resend()"
          class="ib-btn ib-btn-link ib-btn-secondary"
        >
          {{ 'btn.resend' | transloco }}
        </button>
        <br />
        <br />
        <br />
        <button
          mat-button
          type="button"
          (click)="logout()"
          class="ib-btn ib-btn-outline ib-btn-secondary"
        >
          {{ 'btn.logout' | transloco }}
        </button>
      </ng-container>

      <button
        *ngIf="!isLoggedIn"
        mat-button
        type="button"
        (click)="toLogin()"
        class="ib-btn ib-btn-link ib-btn-secondary"
      >
        {{ 'btn.login' | transloco }}
      </button>
    </div>
  </div>
</div>
<ib-footer></ib-footer>
